export enum ReviewType {
    TOOLCHAIN_REVIEW,
    ORGANISATION_REVIEW,
    PRODUCT_REVIEW
}
